import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  videoUrl: null,
  videoId: null,
  videoTitle: null,
  initialVideoLoading: true, // Track if the initial video has loaded
  currentVideoMetaData: null, // Store metadata of the current video
  isPlaying: false,
  hovering: true,
  currentTime: 0,
  totalDuration: 0,
  videoUrl: null,
  expirationTime: null,
  isFullscreen: false,
  volume: 100,
  previousVolume: 100, // To store the volume before muting
  volumeHover: false,
  showSettings: false,
  settingsView: 'main', // 'main', 'playbackSpeed', 'quality'
  showStepToastLeft: false,
  showSecondsSteppedLeft: 0,
  showStepToastRight: false,
  volumeToaster: false,
  showSecondsSteppedRight: 0,
  isInteracting: false, // Track if mouse is moving
  isBuffering: false,
  currentVideoPosition: null, // Used by previous and next buttons and accepts number values based on index of flattenedCourse array
  flattenedCourse: [], // Store flattened course videos for navigation
};

const videoPlayerSlice = createSlice({
  name: 'videoPlayer',
  initialState,
  reducers: {
    // Define your reducers here to update the state
    // Suggestion: keep the reducers names similar to the state properties for clarity (i.e., setIsPlaying, setHovering, setCurrentTime, etc.)
    setBooleanState(state, action) {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setVideoUrl(state, action) {
      state.videoUrl = action.payload;
    },
    setCurrentVideoPosition(state, action) {
      state.currentVideoPosition = action.payload;
    },
    setTotalDuration(state, action) {
      state.totalDuration = action.payload;
    },
    setCurrentTime(state, action) {
      state.currentTime = action.payload;
    },
    setExpirationTime(state, action) {
      state.expirationTime = action.payload;
    },
    setVolume(state, action) {
      if(action.payload === 'up') {
        state.volume = Math.min(100, state.volume += 5);
      } else if (action.payload === 'down') {
        state.volume = Math.max(0, state.volume -= 5);
      } else {
        state.volume = action.payload;
      }
    },
    setPreviousVolume(state, action) {
      state.previousVolume = action.payload;
    },
    setShowSecondsSteppedLeft(state, action) {
      if (action.payload === 0) {
        state.showSecondsSteppedLeft = 0;
      } else {
        state.showSecondsSteppedLeft -= action.payload;
      }
    },
    setShowSecondsSteppedRight(state, action) {
      if (action.payload === 0) {
        state.showSecondsSteppedRight = 0;
      } else {
        state.showSecondsSteppedRight += action.payload;
      }
    },
    setSettingsView(state, action) {
      state.settingsView = action.payload;
    },
    setVideoId(state, action) {
      state.videoId = action.payload;
    },
    setFlattenedCourse(state, action) {
      state.flattenedCourse = action.payload;
    },
    setCurrentVideoMetaData(state, action) {
      state.currentVideoMetaData = action.payload;
    },
    setVideoTitle(state, action) {
      state.videoTitle = action.payload;
    },
  },
});

export const { 
    setBooleanState,
    setCurrentVideoPosition,
    setTotalDuration,
    setCurrentTime,
    setVideoUrl,
    setExpirationTime,
    setVolume,
    setPreviousVolume,
    setShowSecondsSteppedLeft,
    setShowSecondsSteppedRight,
    setSettingsView,
    setVideoId,
    setFlattenedCourse,
    setCurrentVideoMetaData,
    setVideoTitle,
 } = videoPlayerSlice.actions;

export default videoPlayerSlice.reducer;